import { useSearchParams } from "react-router-dom";
import { Phone, Clock, ShieldCheck } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { BookingForm } from "@/components/book/BookingForm";
import { SITE } from "@/lib/site";

export default function Book() {
  const [params] = useSearchParams();
  return (
    <>
      <Seo title="Book a Plumber Online in Sydney | Austyle Plumbing" description="Book a Sydney plumber online or request a free quote from Austyle Plumbing. Choose a date and arrival window for domestic, strata, commercial or new build work." />
      <PageHero testid="book-hero" eyebrow="Book online" lines={["Book a time.", "Or get a quote."]}
        intro="Choose an arrival window that suits you, or tell us about the job and we'll price it. We'll confirm every request personally." />
      <section className="bg-porcelain py-16 sm:py-24">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <BookingForm defaultKind={params.get("mode") === "quote" ? "quote" : "booking"} defaultService={params.get("service") || ""} defaultSuburb={params.get("suburb") || ""} />
          </div>
          <aside className="lg:col-span-4 space-y-4">
            <div className="bg-ink text-white p-8 clip-notch lg:sticky lg:top-28">
              <p className="eyebrow text-brass">Rather talk?</p>
              <a href={SITE.tel} data-testid="book-call-link" className="mt-4 flex items-center gap-3 font-wide font-black text-3xl hover:text-brass transition-colors"><Phone className="h-6 w-6 text-brass" />{SITE.phone}</a>
              <ul className="mt-8 space-y-4 text-sm text-slate-300">
                <li className="flex gap-3"><Clock className="h-5 w-5 text-brass shrink-0" />We'll contact you to confirm your booking or quote.</li>
                <li className="flex gap-3"><ShieldCheck className="h-5 w-5 text-brass shrink-0" />{SITE.years} years of Sydney plumbing experience.</li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
